export function extractErrorMessage(body: string, status: number): string {
    if (!body) {
        return `Request failed with status ${status}`;
    }

    try {
        const parsed = JSON.parse(body);
        if (typeof parsed === 'string') {
            return parsed;
        }
        if (parsed && typeof parsed === 'object') {
            const candidate = parsed.error ?? parsed.message ?? parsed.detail;
            if (typeof candidate === 'string' && candidate.length > 0) {
                return candidate;
            }
        }
    } catch {
        // not JSON — fall through and return the raw text
    }

    return body;
}
